module.exports = __webpack_public_path__ + "img/icici_upi.41bfa7c2.png";